import { h } from 'preact';
import { useAdParameters } from '../../common/creative/hooks/useAdParameters';
import { useOptimizedAsset } from '../../common/creative/hooks/useOptimizedAsset';
import { CSSAttribute } from '../../common/types';
import { MPUConfig } from './config';

interface MPUCreativeProps {
  size: { width: number; height: number };
  style?: CSSAttribute;
  onClick?: () => void;
}

export function MPUCreative({ size, style = {}, onClick }: MPUCreativeProps) {
  const { config } = useAdParameters<MPUConfig>();
  const assetUrl = useOptimizedAsset(config.image);

  return (
    <img
      src={assetUrl}
      style={{
        ...style,
        ...size,
        display: 'block',
        margin: '0 auto',
      }}
      onClick={onClick}
      alt="MPU Ad Image"
    />
  );
}
